module.exports = __webpack_public_path__ + "web/img/mvp-cardbt.e4a14751.png";